import { BasicReconnectDialogProperties } from "@goodgamestudios/core";
import { CommonDialogNames } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2ReconnectDialog extends Poker2Dialog {
    public static NAME: string;

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }
    protected applyProperties(): void {
        this.reconnectDialog.btn_ok.label = this.reconnectDialogProperties.buttonLabel_reconnect;
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.reconnectDialog.txt_title, this.reconnectDialogProperties.title);
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.reconnectDialog.txt_copy, this.reconnectDialogProperties.copy, 7);
        this.reconnectDialog.btn_close.visible = false;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.reconnectDialog.btn_ok:
                this.hide();
                if (this.reconnectDialogProperties.functionReconnect != null)
                    this.reconnectDialogProperties.functionReconnect();
                break;
        }
    }

    protected get reconnectDialogProperties(): BasicReconnectDialogProperties {
        return this.properties as BasicReconnectDialogProperties;
    }

    protected get reconnectDialog(): Library.PokerInterface.PokerStandardOk {
        return this.disp as Library.PokerInterface.PokerStandardOk;
    }

    public static __initialize_static_members() {
        Poker2ReconnectDialog.NAME = CommonDialogNames.ReconnectDialog_NAME;
    }
}
Poker2ReconnectDialog.__initialize_static_members();
